export default {
  assetDocumentation: 'Anlagendokumentation',
  noAssetBlobs: 'Anlage {asset} hat keine Dokumentation.',
  overheadTime: 'Verwaltungszeit',
  engineerNote: 'Zugewiesene Person',
  managerFeedback: 'Manager',
  deleteLastEventMessage: 'Sie sind dabei, das letzte Ereignis in der Serie zu löschen. Dies führt zur Löschung der gesamten Serie. {text}',
  inProgressStateWarning: 'Bitte kennzeichnen Sie die Aufgaben als „Abgeschlossen“ oder „Ausgelassen". Falls Aufgaben ausgelassen wurden, hinterlassen Sie bitte für jede ausgelassene Aufgabe einen Kommentar.',
  inReviewStateWarning: 'Um ein Ereignis als „Abgeschlossen“ zu markieren, müssen alle Aufgaben als „Akzeptiert“ gekennzeichnet sein.',
};
